import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, Switch, Redirect, Route, useRouteMatch } from "react-router-dom";

import { updateLoginStatus } from "../../../store/userSlice";
import { SubPageHeader } from "../../SubPageHeader";
import { ClusterEarthquake } from "./ClusterEarthquake";
import { AnnualReports } from "./AnnualReports";
import { IntensitySimulation } from "./IntensitySimulation";
import { Seismicity } from "./Seismicity";
import { SeismicDesignCategoryMap } from "./SeismicDesignCategoryMap";
import { WaveformApproximation } from "./WaveformApproximation";

export function SeismicAnalysis() {
  let match = useRouteMatch();
  const currentPath = window.location.pathname;
  const currentPage = currentPath.substring(
    currentPath.lastIndexOf("/") + 1,
    currentPath.length
  );

  // Update login status
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateLoginStatus());
  }, [currentPage, dispatch]);

  return (
    <div>
      <SubPageHeader
        categoryUrl={match.path}
        categoryName="analysis"
        pageName={currentPage}
      />
      <Switch>
        <Route exact path={`${match.path}`}>
          <Redirect to={`${match.path}/major-earthquakes`} />
        </Route>
        <Route path={`${match.path}/major-earthquakes`}>
          <ClusterEarthquake />
        </Route>
        <Route path={`${match.path}/annual-report`}>
          <AnnualReports />
        </Route>
        <Route path={`${match.path}/intensity-simulation`}>
          <IntensitySimulation />
        </Route>
        <Route path={`${match.path}/interactive-map`}>
          <Seismicity />
        </Route>
        <Route path={`${match.path}/seismic-design-category-map`}>
          <SeismicDesignCategoryMap />
        </Route>
        <Route path={`${match.path}/waveform-approximation`}>
          <WaveformApproximation />
        </Route>
        <Route>
          <div className="container">
            <div className="sub-container">
              <h3>페이지를 찾을 수 없습니다.</h3>
              <span>
                <Link to="/">홈 화면으로 가기</Link>
              </span>
            </div>
          </div>
        </Route>
      </Switch>
    </div>
  );
}
